import { keycloakAuthState } from "@/helpers/keycloakAuthState";

import { handleSearchParams } from "./handleSearchParams";

interface GetTransactionStatusParams {
  transferServerUrl: string;
  transactionId: string;
  token: string;
}

export const getTransactionStatus = async ({
  transferServerUrl,
  transactionId,
  token,
}: GetTransactionStatusParams): Promise<string> => {
  const params = handleSearchParams({
    id: transactionId,
  });

  // This targets an external SEP-24 transfer server, not the SDP backend.
  // Only include Authorization header; avoid SDP-Tenant-Name to prevent CORS issues.
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };

  if (!keycloakAuthState.isKeycloakMode && token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const response = await fetch(`${transferServerUrl}/transaction${params}`, {
    method: "GET",
    credentials: keycloakAuthState.isKeycloakMode ? "include" : undefined,
    headers,
  });

  if (!response.ok) {
    throw new Error("Unable to fetch transaction");
  }

  const json = await response.json();
  const status = json?.transaction?.status;
  if (!status) {
    throw new Error("Transaction status is missing");
  }

  return status.toLowerCase();
};
